export default __webpack_public_path__ + "static/media/0x25788a1a171ec66da6502f9975a15b609ff54cf6.59bc0f9c.webp";